import store from '@/store'
import router from '@/router'
import { getSessionId } from '@/utils/session.util'
import { ServiceRequest } from '@/types/conductor'
import { useProfilesStore } from '@/store/modules/userProfile'

// ----------------- CONSTANTS -----------------
const VERSION = '2.1'

// ----------------- Helpers -----------------
export function getProtocol(): string {
  const stbApiIsSecure: boolean = store.getters['configModule/stbApiIsSecure']
  return stbApiIsSecure ? 'https' : 'http'
}

export function getApiHost(): string {
  const stbApiHost: string = store.getters['configModule/stbApiHost']
  if (!stbApiHost || stbApiHost === '') {
    console.error('Missing stbApiHost')
    throw new Error('Missing stbApiHost')
  }
  return stbApiHost
}

export async function getProtocolAndApiHost(): Promise<string> {
  const stbApiHost = store.getters['configModule/stbApiHost']
  const stbApiIsSecure = store.getters['configModule/stbApiIsSecure']

  if (!stbApiHost || stbApiHost === '') {
    console.error('MISSING stbApiHost')
    throw new Error('MISSING stbApiHost')
  }

  const protocol = stbApiIsSecure ? 'https' : 'http'
  return `${protocol}://${stbApiHost}`
}

// ----------------- Locale & Scopes -----------------
export function getLocale(): string {
  const settingsLanguage: string = store.getters['settingsModule/language']
  if (settingsLanguage && settingsLanguage !== '') {
    return settingsLanguage
  }
  // Default fallback
  return 'en'
}

export function getScopes(): string[] | null {
  const scopes: string[] = store.getters['scopeModule/enabledScopes']
  if (scopes && scopes.length > 0) {
    return scopes
  }
  return null
}

// ----------------- Client Agent -----------------
export function getClientAgentString(): string {
  // Determine client dynamically based on route path
  const currentPath = router.currentRoute.value.path
  let client = 'share-web'

  if (currentPath.includes('/odds')) {
    client = 'share-odds'
  } else if (currentPath.includes('/bet')) {
    client = 'share-direct'
  }

  // Get user info from Pinia store
  const userProfileStore = useProfilesStore()
  const userId = userProfileStore?.profile?.userId ?? 0
  const username = userProfileStore?.profile?.username ?? 'Guest'

  return `client=${client};version=${VERSION};userId=${userId};username=${username}`
}

// ----------------- Request Utilities -----------------
let _requestId = 100

function allocateRequestId(): number {
  return ++_requestId
}

export function getBaseRequestData() {
  return {
    requestId: Date.now(),
    clientAgentString: getClientAgentString(),
  }
}

// ----------------- Service Request Builders -----------------
export function buildSessionlessServiceRequest(): ServiceRequest {
  const requestId = allocateRequestId()
  return {
    requestId,
    clientAgentString: getClientAgentString(),
  }
}

export function buildServiceRequest(): ServiceRequest {
  const sessionId = getSessionId()
  const sessionlessServiceRequest = buildSessionlessServiceRequest()

  return {
    ...sessionlessServiceRequest,
    sessionId,
  }
}